<app-backdrop />
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="main-container">

    <main>

        <div class="router-wrap">
            @if (bannerService.showBanner()) {
                <div class="container">
                    <div class="alert alert-warning text-center mt-2" role="alert">
                    <a [routerLink]="['/banner-promo']" class="flash alert-link banner-promo">
                        {{ bannerService.titolo() }}
                    </a>
                    </div>
                </div>
            }

            <router-outlet />
        </div>

        <app-footer></app-footer>
    </main>
</div>
<app-cart-sidebar/>
